import { totalAmount, totalOf, unitRate, type TotalAmount } from '@/lib/money';
import { pairOf } from '@/lib/task-currency';
import type { OfferRow } from '@/features/tasks/types';

/**
 * BURONUN GONDERECEGI TUTAR — "Islemi tamamla" penceresi (2026-09-26).
 *
 * Takasin iki bacagi (lib/task-accounts.ts): buronun GIDEN bacagi musterinin GELEN bacagidir
 * ve musterinin talebe bagladigi hesap (`taskData.selectedAccount`) tam olarak o bacaktir.
 *   ALIS  (musteri dovizi aliyor)  -> buro islem miktarini (`taskAmount`) ciftin base
 *                                     biriminde gonderir: USD talebinde USD, EUR/USD'de EUR.
 *   SATIS (musteri dovizi satiyor) -> buro TOPLAMI (birim kur x miktar) karsi birimde
 *                                     gonderir: TRY, EUR/USD'de USD.
 * Tutarlar kartin zaten gosterdigi iki sayidir (baslik: taskAmount, izgara: totalOf); burada
 * yeni bir hesap yok, yalniz hangisinin GONDERILECEGI secimi. Mobil karsiligi:
 * utils/account.ts determineSendingSumForExchange.
 */
export type Payout = Readonly<{ total: TotalAmount; currency: string }>;

export const payoutOf = (
  offer: Pick<OfferRow, 'taskTypeCode' | 'taskIsBuying' | 'taskAmount' | 'offerPrice'>,
): Payout => {
  const pair = pairOf(offer.taskTypeCode);
  if (offer.taskIsBuying) return { total: totalAmount(offer.taskAmount), currency: pair.currency };
  return {
    total: totalOf(unitRate(offer.offerPrice), offer.taskAmount),
    currency: pair.secondCurrency,
  };
};
